export const LOTTERY_PERMISSION_GROUP = 'Lottery';
export const LIST_LOTTERIES_PERMISSION = 'LIST_LOTTERIES';
export const LOTTERY_PRIVILEGE_MANAGER_ROLES = ['SUPER_ADMIN', 'ADMIN'] as const;

export type LotteryPrivilegeManagerRole = (typeof LOTTERY_PRIVILEGE_MANAGER_ROLES)[number];

export function isLotteryPrivilegeManagerRole(roleValue?: string): roleValue is LotteryPrivilegeManagerRole {
  return LOTTERY_PRIVILEGE_MANAGER_ROLES.includes(roleValue as LotteryPrivilegeManagerRole);
}

/** Roles & Permissions Terminal tab: system admins (isSuper) or tenant Admin/Super Admin roles. */
export function canManageLotteryInRolesPage(roleValue?: string, isSuper?: boolean): boolean {
  if (isSuper === true) {
    return true;
  }

  return isLotteryPrivilegeManagerRole(roleValue);
}

/** Left nav + lottery routes: Admin/Super Admin, or any role granted LIST_LOTTERIES. */
export function canAccessLotteryFeature(roleValue?: string, privileges?: string[]): boolean {
  if (isLotteryPrivilegeManagerRole(roleValue)) {
    return true;
  }

  return privileges?.includes(LIST_LOTTERIES_PERMISSION) ?? false;
}
